const features = [
  {
    tag: "检索",
    icon: "ri-search-2-line",
    title: "文献罗盘",
    desc: "聚合中科院 1.7 亿科技论文、arXiv 240 万预印本，极速检索、全文 PDF 阅读与文献对比。",
  },
  {
    tag: "调研",
    icon: "ri-robot-2-line",
    title: "深度研究",
    desc: "多智能体协作，动态检索文献库+网络资源+工具，持续多轮「思考→执行→验证」，输出完整研究报告。",
  },
  {
    tag: "入口",
    icon: "ri-chat-ai-line",
    title: "科学对话",
    desc: "磐石核心对话入口，五种模式：极速问答 / 研究模式 / 学术综述 / 学术 PPT / 学术配图 / 学术海报。",
  },
  {
    tag: "评估",
    icon: "ri-award-line",
    title: "创新评价",
    desc: "对科研选题、申请书、论文、成果进行多维评估（创新性、可行性、风险），替代靠经验拍脑袋的决策方式。",
  },
  {
    tag: "研讨",
    icon: "ri-team-line",
    title: "ScienceClaw 磐石科学家",
    desc: "垂直领域 AI 专家，可单聊咨询或加入研讨厅群聊协作，记忆用户偏好、沉淀工作流，组成虾群协作脑暴。",
  },
  {
    tag: "沉淀",
    icon: "ri-book-2-line",
    title: "知识库",
    desc: "个人/团队文献与知识的存储、管理、检索平台，支持 RAG+知识图谱，让 AI 基于你的文献库做推理而非仅做摘要。",
  },
  {
    tag: "入口",
    icon: "ri-newspaper-line",
    title: "科研资讯",
    desc: "学术资讯聚合平台，汇聚 100+ 学术信源，支持订阅推送和 AI 解读，是流量入口与转化漏斗起点。",
  },
  {
    tag: "基座",
    icon: "ri-cpu-line",
    title: "SciClaw 学术龙虾",
    desc: "磐石平台的 AI Agent 基座，生长在 1.7 亿论文知识基座之上，具备科研推理能力、成长记忆和多虾协作能力。",
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-24 bg-[#0a0a0a]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-block text-xs text-[#3d69e8] font-medium tracking-widest uppercase mb-4">功能详情</div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">磐石产品能力全景</h2>
          <div className="w-12 h-0.5 bg-[#3d69e8] mx-auto mb-4"></div>
          <p className="text-sm text-white/40">覆盖科研全流程的 8 大核心能力模块</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-[#111111] hover:bg-[#161616] border border-white/8 hover:border-white/15 rounded-2xl p-6 transition-all cursor-pointer"
            >
              <div className="text-[10px] text-white/30 uppercase tracking-widest mb-4">{f.tag}</div>
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#3d69e8]/10 border border-[#3d69e8]/20 mb-4 group-hover:bg-[#3d69e8]/20 transition-colors">
                <i className={`${f.icon} text-lg text-[#3d69e8]`}></i>
              </div>
              <h3 className="text-sm font-semibold text-white mb-2">{f.title}</h3>
              <p className="text-xs text-white/40 leading-relaxed mb-5">{f.desc}</p>
              <a href="#" className="inline-flex items-center gap-1 text-xs text-[#3d69e8] hover:text-[#6b90f0] transition-colors no-underline cursor-pointer">
                Learn more <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
